import { render, staticRenderFns } from "./LettersBase.vue?vue&type=template&id=a4c68890"
import script from "./LettersBase.vue?vue&type=script&lang=js"
export * from "./LettersBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports